import { useEffect } from "react";
import { useNavVisibilityStore } from "&/navVisibility";

export const useHideNav = () => {
  const setVisible = useNavVisibilityStore((s) => s.setVisible);

  useEffect(() => {
    setVisible(false);
    return () => setVisible(true);
  }, [setVisible]);
};

export default useHideNav;
